module.exports = {"heading":"Select your favorite store or submit new store to the list","placeholder1":"Your favorite store URL","button":"Submit","interneterr":"Please check your internet connection","invalidurl":"Please enter valid delivery now url","select":"Select...","milktea":"Your favorite milktea","rangeLowest":"Lowest price","rangeHighest":"Highest price","total":"Total item(s):","shareLink":"Get shared link","copyLink":"Copy link to clipboard"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/en.json
// module id = 471
// module chunks = 0